<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    const ua = navigator.userAgent;
    const isMobile = /Mobile/i.test(ua);
    const isAndroid = /(?:Android)/.test(ua);
    const isFireFox = /(?:Firefox)/.test(ua);
    const isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua));

    if (isMobile) {
      location.href = "http://kjzx.medbooks.com.cn:7002/home#/";
    } else if (isTablet) {
      location.href = "http://kjzx.medbooks.com.cn:7001/#/";
    } else {
      return
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  background-color: #f7f7f7;
}

* {
  box-sizing: border-box;
}
body {
  padding: 0;
  margin: 0;
}
html,
body {
  /* 定死font-size 避免浏览器不同导致样式错乱 */
  position: relative;
  font-family: "Microsoft YaHei";
  font-size: 14px;
  min-width: 1200px;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
</style>
